/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateComplaintResponse
 */
export interface CreateComplaintResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateComplaintResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateComplaintResponse
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof CreateComplaintResponse
     */
    jwt: string;
}

/**
 * Check if a given object implements the CreateComplaintResponse interface.
 */
export function instanceOfCreateComplaintResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "password" in value;
    isInstance = isInstance && "jwt" in value;

    return isInstance;
}

export function CreateComplaintResponseFromJSON(json: any): CreateComplaintResponse {
    return CreateComplaintResponseFromJSONTyped(json, false);
}

export function CreateComplaintResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateComplaintResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'password': json['password'],
        'jwt': json['jwt'],
    };
}

export function CreateComplaintResponseToJSON(value?: CreateComplaintResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'password': value.password,
        'jwt': value.jwt,
    };
}

